/* eslint-disable no-console */
/* eslint-disable no-process-env */
import {fetch} from '@deere/scs-fetch';

const baseUrl = process.env.REACT_APP_CONTACT_US_API_URL ?? '';

export const getUserInfoFromContactUsAPI = async (tokenUser, userId) => {
    if (typeof userId !== 'string' && userId.trim().length <= 0) {
        return null;
    }
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${tokenUser}`
        }
    };

    return fetch(`${baseUrl}/contactus/userinfo/${userId}`, requestOptions).then((response) => {
        return response ? response : null;
    })
        .catch((error) => {
            throw error;
        });
};

export const getContactUsParams = async (tokenUser) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${tokenUser}`
        }
    };

    return fetch(`${baseUrl}/contactus/param`, requestOptions).then((response) => {
        return response ? response : [];
    })
        .catch((error) => {
            throw error;
        });
};

export const getContactUsApps = async (tokenUser) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${tokenUser}`
        }
    };

    return fetch(`${baseUrl}/contactus/apps`, requestOptions).then((response) => {
        return response ? response : [];
    })
        .catch((error) => {
            throw error;
        });
};
